module.exports = (__webpack_require__(0))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/View.js from dll-reference girder_plugin_large_image
// module id = 18
// module chunks = 0